import { render, staticRenderFns } from "./techVideo.vue?vue&type=template&id=6c11c7a7&scoped=true&lang=pug"
import script from "./techVideo.vue?vue&type=script&lang=js"
export * from "./techVideo.vue?vue&type=script&lang=js"
import style0 from "./techVideo.vue?vue&type=style&index=0&id=6c11c7a7&prod&lang=scss&scoped=true"
import style1 from "./techVideo.vue?vue&type=style&index=1&id=6c11c7a7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c11c7a7",
  null
  
)

export default component.exports